import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { nameToSlug } from '../utils/slug';
import './CameraList.css';
import WeatherView from '../components/WeatherView';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

function CameraList() {
  const [cameras, setCameras] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCameras = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/cameras`);
        if (!response.ok) {
          throw new Error('Failed to fetch cameras');
        }
        const data = await response.json();
        // Filter only enabled cameras
        const enabledCameras = data.filter(cam => cam.enabled);
        setCameras(enabledCameras);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching cameras:', err);
        setError(err.message);
        setLoading(false);
      }
    };

    fetchCameras();
  }, []);

  if (loading) {
    return (
      <div className="app-container">
        <div className="loading-screen">
          <div className="spinner"></div>
          <p>Camera's laden...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="app-container">
        <div className="error-screen">
          <h2>⚠️ Fout</h2>
          <p>{error}</p>
          <p className="error-hint">Zorg ervoor dat de backend server draait op {API_BASE_URL}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="app-container">
      <header className="app-header">
        <h1>🎥 Hartel Webcam Viewer</h1>
        <p className="subtitle">Selecteer een camera om te bekijken</p>
      </header>

      {cameras.length === 0 ? (
        <div className="no-cameras">
          <p>Geen camera's beschikbaar</p>
        </div>
      ) : (
        <div className="camera-list">
          {cameras.map((camera) => (
            <Link
              key={camera.name}
              to={`/camera/${nameToSlug(camera.name)}`}
              className="camera-card"
            >
              <div className="camera-card-icon">📹</div>
              <div className="camera-card-info">
                <h3>{camera.name}</h3>
                <p className="camera-card-type">Webcam</p>
              </div>
              <div className="camera-card-arrow">→</div>
            </Link>
          ))}
        </div>
      )}
      <WeatherView />
    </div>
  );
}

export default CameraList;

